import type { CarePlanResponse } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getCarePlan(patientId: string): Promise<CarePlanResponse> {
  return sharedRequestsTyped.get_care_plan({ context: { showLoader: false }, patientId });
}
